export default __webpack_public_path__ + "static/media/IMG_4889.cb76558f.png";